/* @flow */
import React, { useCallback } from "react";
import dayjs from "dayjs";

import Input from "../../components/Input";
import WidgetReadOnlyEmptyValue from "../../components/WidgetReadOnlyEmptyValue";

type Props = {|
  id: string,
  name?: string,
  onBlur?: (event: any) => any,
  onChange?: (event: any) => any,
  value?: string,
  defaultValue?: string,
  min?: string,
  max?: string,
  step?: number,
  readOnly?: boolean,
  isOnline?: boolean,
|};

const DateWidget = ({
  id,
  name,
  onBlur,
  onChange,
  value,
  defaultValue,
  min,
  max,
  step = 1,
  readOnly = false,
  isOnline,
}: Props) => {
  const handleChange = useCallback(
    (event: any) => {
      if (readOnly) return;
      onChange && onChange(event);
    },
    [onChange, readOnly]
  );

  if (readOnly) {
    return <div>{value || defaultValue || <WidgetReadOnlyEmptyValue />}</div>;
  }

  return (
    <div>
      <Input
        type={"date"}
        pattern={"[0-9]{4}-[0-9]{2}-[0-9]{2}"}
        id={id}
        name={name}
        onBlur={onBlur}
        onChange={handleChange}
        value={value != null ? value : defaultValue}
        min={min}
        max={max}
        step={step}
        readOnly={readOnly || !isOnline}
      />
    </div>
  );
};

DateWidget.mapSchemaToProps = (schema: Object, uiSchema: Object) => {
  let props = {};
  const defaultValue = schema.default || uiSchema["ui:emptyValue"];
  props.defaultValue =
    defaultValue === "current" ? dayjs().format("YYYY-MM-DD") : defaultValue;
  props.autoFocus = !!uiSchema["ui:autofocus"];
  props.min = schema.minimum;
  props.max = schema.maximum;
  props.step = schema.multipleOf;
  props.readOnly = schema.readOnly;
  return props;
};

export default DateWidget;

/*

schema: {
  "type": "string",
  "order": 2,
  "title": {
    "it": "Listino valido dal giorno"
  }
},

ui schema: {
  "ui:widget":"date",
  "ui:propertyOrder":2
}
*/
